"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArrayOfAssertion_1 = __importDefault(require("../../typeAssertions/valueIsArrayOfAssertion"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const getEnsuredAppIdFromProcessor_1 = __importDefault(require("../getEnsuredAppIdFromProcessor"));
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
const buildCallableUploadFile = (args) => async ({ functionId, entryVars: { uri, permissionRequestTile, permissionRequestMessage, maxFileSize, }, callbacks, executeProcesses, processor, }) => {
    try {
        if (!await args.checkPermissions({
            permissionRequestTile,
            permissionRequestMessage,
        })) {
            throw new Error('You need to accept the permissions');
        }
        const validateSize = (size) => {
            if (!maxFileSize
                || maxFileSize === 'none') {
                return;
            }
            if (!(0, valueIsString_1.default)(maxFileSize)) {
                throw new Error(`Invalid file size limit: ${maxFileSize}`);
            }
            let maxFileSizeN;
            try {
                maxFileSizeN = (0, getNumberFromUnknown_1.default)(maxFileSize.replace('mb', ''));
            }
            catch (_a) {
                throw new Error(`Invalid file size limit: ${maxFileSize}`);
            }
            const sizeMB = size / 1e+6;
            if (sizeMB > maxFileSizeN) {
                throw new Error('The file size is over the max file size allowed.');
            }
        };
        const CALLER_NAME = 'uploadFile';
        const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)(CALLER_NAME, processor);
        const appId = (0, getEnsuredAppIdFromProcessor_1.default)(CALLER_NAME, processor);
        const refStorage = processor.root.firebase.storage().ref('media')
            .child(projectId)
            .child(appId)
            .child('dataApplications');
        let downloadURLs = [];
        if ((0, valueIsArrayOfAssertion_1.default)(valueIsString_1.default)(uri)) { // Validate if is an array of uris
            const getUrl = await args.getFileInfo({
                refStorage,
                uris: uri,
                validateSize,
            });
            downloadURLs = await Promise.all(getUrl.map((fileId) => refStorage.child(fileId).getDownloadURL()));
        }
        else if ((0, valueIsString_1.default)(uri) && /^http/.test(uri)) {
            downloadURLs = uri;
        }
        else if ((0, valueIsString_1.default)(uri)) {
            const getUrl = await args.getFileInfo({
                refStorage,
                uris: [uri],
                validateSize,
            });
            const fileId = getUrl[0];
            downloadURLs = await refStorage.child(fileId).getDownloadURL();
        }
        executeProcesses(functionId, callbacks.successProcess, downloadURLs);
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, error);
    }
    return null;
};
exports.default = buildCallableUploadFile;
